import $ from 'jquery'
import reqwest from 'reqwest'
import Admin from './Admin'
import { each, parseJson } from '../util'

/**
 * @module DataTable
 * NOTE: JQuery dependency, do not import in main.js.
 */
const DataTable = (() => {
  const generateAttributesColumns = (attributes, table) => {
    return Object.entries(attributes).map((column, i) => {
      const key = column[0]

      if (typeof column[1] == 'string') {
        column[1] = {
          type: 'data',
          title: column[1]
        }
      }

      const col = {
        key: key,
        type: column[1]['type'],
        title: column[1]['title'],
        link: column[1]['link'],
        action: column[1]['action'],
      }

      if (table.hasAttribute('data-order') && i == 0) {
        col.className = 'reorder'
      }

      return col
    })
  }

  const generateDataColumns = (data, attributes) => {
    return data.map((row) => {
      return attributes.map((attribute, i) => {
        if (attribute.type == 'data') {
          return row[i]
        } else if (attribute.type == 'link') {
          const separator = attribute.link.path.includes('?') ? '&' : '?'
          return `
            <a
              class="c-button c-button--main c-button--small datatable-action"
              href="${attribute.link.path}${separator}${attribute.link.param}=${row[i]}"
              data-method="${attribute.link.method || 'get'}"
              data-value="${row[i]}"
            >${attribute.link.label}</a>
          `
        } else if (attribute.type == 'action') {
          return `
            <button
              class="c-button c-button--main c-button--small datatable-action ${attribute.action.class}"
              data-${attribute.action.data}="${row[i]}"
              data-value="${row[i]}"s
            >${attribute.action.label}</button>
          `
        }
      })
    })
  }

  const initializeTable = (table) => {
    const attributes = generateAttributesColumns(parseJson(table.getAttribute('data-attributes')), table)
    if (!attributes) throw new Error('DataTable -> You should insert a data-attributes with a valid JSON string to initialize the table')
    const endpoint = table.getAttribute('data-endpoint')
    if (!endpoint) throw new Error('DataTable -> You should insert a data-endpoint to initialize the table')

    const options = {
      columns: attributes,
      processing: false,
      serverSide: true,
      bSort: false,
      lengthMenu: [50, 100],
      ajax: {
        url: endpoint,
        type: 'GET',
        dataFilter: (d) => {
          const json = parseJson(d)
          json.recordsTotal = json.total
          json.recordsFiltered = json.filtered
          json.data = generateDataColumns(json.data, attributes)

          return JSON.stringify(json)
        }
      }
    }
    if (table.hasAttribute('data-order')) {
      options.rowReorder = {
        update: true,
        selector: 'td:first-child'
      }
    }
    const datatable = $(table).DataTable(options)

    datatable.on('draw.dt', () => {
      Admin.manageAddVideoToCourse()
      Admin.manageAddWorkoutToBundle()
      Admin.manageAddWorkoutToChallenge()
      Admin.manageAddVideoToChallenge()
      Admin.manageAddWtaLabWorkout()
      Admin.manageRemoveWtaLabWorkout()
      Admin.manageAddWtaLabVideo()
      Admin.manageRemoveWtaLabVideo()
      Admin.manageAddFaqToCourse()
      Admin.manageAddCourseToTraining()
    })
    
    if (table.hasAttribute('data-order')) {
      const orderSettings = JSON.parse(table.getAttribute('data-order'))
      datatable.on('row-reorder', (e, diff, edit) => {
        diff.map((d) => {
          const value = d.node.querySelector('.datatable-action').getAttribute('data-value')
          const data = { position: d.newPosition }
          data[orderSettings.param] = value
          data[authParam] = authToken

          console.log('New position', d.newPosition)

          reqwest({
            url: orderSettings.url,
            method: 'post',
            data: data,
            success: (response) => {
              console.log(response)
            }
          })
        })
      })
    }
  }

  const init = () => {
    const tables = document.querySelectorAll('.js-datatable')
    if (!tables || tables.length < 1) return

    each(tables, (i, table) => initializeTable(table))
  }

  return {
    init
  }
})()

export default DataTable



// WEBPACK FOOTER //
// app/javascript/scripts/components/DataTable.js